/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-28 14:43:28
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/Element/Elements.tsx
 */
import { Element } from 'src/components/Layouts';

export default Element;

// import css from './css.less';
// import React from 'react';
// import ErrorBoundary from 'src/components/ErrorBoundary';

// const Element = (props) => {
//   const { style, children } = props;
//   return (
//     <div className={css.container} style={style || {}}>
//       {children}
//     </div>
//   );
// };
// export default ErrorBoundary(Element);
